import(/* webpackMode: "eager", webpackExports: ["ConfigProvider","App"] */ "__barrel_optimize__?names=App,ConfigProvider!=!/codebuild/output/src3924123758/src/mini-apps/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3924123758/src/mini-apps/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager", webpackExports: ["ClientLayout"] */ "/codebuild/output/src3924123758/src/mini-apps/src/app/clientLayout.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3924123758/src/mini-apps/src/app/globals.css");
